import { Helmet } from "react-helmet-async";
import { OG_DEFAULT_IMAGE, OG_IMAGE_ALT, SITE_URL } from "../constants/config";

function getAbsoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return SITE_URL;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`}`;
}

function getAbsoluteOgImage(image) {
  if (!image) return getAbsoluteUrl(OG_DEFAULT_IMAGE);
  if (image.startsWith("http")) return image;
  return getAbsoluteUrl(image);
}

function buildFaqJsonLd(faqItems) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export default function PageMeta({
  title,
  description,
  image,
  path = "/",
  faqItems,
}) {
  const canonicalUrl = getAbsoluteUrl(path);
  const ogImage = getAbsoluteOgImage(image || OG_DEFAULT_IMAGE);
  const faqJsonLd = faqItems?.length ? buildFaqJsonLd(faqItems) : null;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={OG_IMAGE_ALT} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      {faqJsonLd && (
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      )}
    </Helmet>
  );
}
